if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        productsToShow: 0,
        productsToShowMax: 10,
        storageKey: 'recently-viewed',
        init() {
          if (document.getElementById('shopify-section-recently-viewed')) {
            this.productsToShow = document.getElementById('shopify-section-recently-viewed').getAttribute("x-products-to-show");
          }
        },
        normalizeProduct(productViewed, variantViewed = productViewed) {
          if (typeof productViewed === 'object' && productViewed !== null) {
            return {
              productId: String(productViewed.productId || productViewed.id || ''),
              variantId: String(productViewed.variantId || productViewed.variant_id || productViewed.productId || productViewed.id || '')
            };
          }

          const productValue = String(productViewed || '');
          if (productValue.includes(':')) {
            const [productId, variantId] = productValue.split(':');
            return {
              productId: productId || '',
              variantId: variantId || productId || ''
            };
          }

          return {
            productId: productValue,
            variantId: String(variantViewed || productValue)
          };
        },
        getRecentProducts() {
          if (!localStorage.getItem(this.storageKey)?.length) return [];

          try {
            return JSON.parse(localStorage.getItem(this.storageKey))
              .map((product) => this.normalizeProduct(product))
              .filter((product) => product.productId && product.variantId);
          } catch (error) {
            localStorage.removeItem(this.storageKey);
            return [];
          }
        },
        showProductRecently() {
          this.show = this.getRecentProducts().length > 0;
        },
        setProduct(productViewed, variantViewed = productViewed) {
          const currentProduct = this.normalizeProduct(productViewed, variantViewed);
          if (!currentProduct.productId || !currentProduct.variantId) return;

          const productList = this.getRecentProducts().filter((product) => {
            if (product.productId === currentProduct.productId && product.variantId === product.productId) return false;
            return product.productId !== currentProduct.productId || product.variantId !== currentProduct.variantId;
          });
          const newData = [currentProduct, ...productList].slice(0, this.productsToShowMax);
          localStorage.setItem(this.storageKey, JSON.stringify(newData));
          this.show = newData.length > 0;
        },
        renderSelectedProducts(source, products) {
          const list = source?.querySelector('.splide__list');
          if (!list) return;

          const slides = Array.from(list.querySelectorAll('[data-recently-viewed-product-id]'));
          const selectedSlides = [];
          const usedSlides = new Set();

          products.forEach((product) => {
            let slide = slides.find((candidate) => {
              return candidate.dataset.recentlyViewedProductId === product.productId
                && candidate.dataset.recentlyViewedVariantId === product.variantId;
            });

            if (!slide) {
              slide = slides.find((candidate) => {
                const variantIds = (candidate.dataset.recentlyViewedVariantIds || '').split(',').filter(Boolean);
                return candidate.dataset.recentlyViewedProductId === product.productId
                  && variantIds.includes(product.variantId);
              });
            }

            if (!slide) {
              slide = slides.find((candidate) => candidate.dataset.recentlyViewedProductId === product.productId);
            }

            if (slide && !usedSlides.has(slide)) {
              selectedSlides.push(slide.cloneNode(true));
              usedSlides.add(slide);
            }
          });

          if (!selectedSlides.length) {
            this.show = false;
            return;
          }

          list.innerHTML = '';
          selectedSlides.forEach((slide) => list.appendChild(slide));
        },
        getProductRecently(sectionId, productId, variantId = productId) {
          let products = this.getRecentProducts();
          if (products.length) {
            products = productId ? products.filter((product) => {
              return product.productId !== String(productId) || product.variantId !== String(variantId || productId);
            }) : products;
            products = products.slice(0, this.productsToShow);
          }

          if (!products.length) {
            this.show = false;
            return;
          }

          const el = document.getElementById("shopify-section-recently-viewed");
          const productIds = [...new Set(products.map((product) => product.productId))];
          const productQuery = productIds.map((productId) => "id:" + productId);
          const variantQuery = products.map((product) => `rv_${product.productId}_${product.variantId}`);
          const query = [...productQuery, ...variantQuery].join(' OR ');
          var search_url = `${Shopify.routes.root}search?section_id=${ sectionId }&type=product&q=${encodeURIComponent(query)}`;
          fetch(search_url).then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              console.log(error)
              throw error;
            }
    
            return response.text();
          })
          .then((text) => {
            const source = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-recently-viewed');
            if (!source) return;
            this.renderSelectedProducts(source, products);
            el.innerHTML = source.innerHTML;
          })
          .catch((error) => {
            throw error;
          });
        },
        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');
          if (result === true) {
            localStorage.removeItem(this.storageKey);
            this.show = false;
          }
        }
      })
    })
  });
}
